export enum OutreachType {
  Email = 'Email',
  Phone = 'Phone',
  Whatsapp = 'Whatsapp',
  Indeed = 'Indeed',
  Werknl = 'Werknl',
  Linkedin = 'Linkedin',
  LinkedinInmail = 'LinkedinInmail',
  RJCommHub = 'RJCommHub',
}
